"use client";

import React from "react";

export default function PrivacyPolicyPage() {
	return (
		<div className='privacy-wrapper'>
			<style jsx>{`
				.privacy-wrapper {
					background-color: #f5f7fa;
					min-height: 100vh;
					display: flex;
					justify-content: center;
					align-items: flex-start;
					padding: 60px 20px;
					font-family: "Inter", Arial, sans-serif;
					color: #333;
				}

				.privacy-container {
					background: #fff;
					max-width: 900px;
					width: 100%;
					padding: 50px 60px;
					border-radius: 16px;
					box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
				}

				.privacy-title {
					font-size: 2.4rem;
					font-weight: 700;
					color: #111;
					margin-bottom: 10px;
				}

				.privacy-meta {
					color: #666;
					font-size: 0.95rem;
					margin-bottom: 40px;
				}

				h2 {
					font-size: 1.4rem;
					color: #111;
					margin-top: 40px;
					margin-bottom: 12px;
				}

				p {
					line-height: 1.7;
					margin-bottom: 16px;
				}

				ul {
					list-style: disc;
					margin-left: 25px;
					margin-bottom: 16px;
				}

				a {
					color: #0077cc;
					text-decoration: none;
				}

				a:hover {
					text-decoration: underline;
				}

				hr {
					border: none;
					border-top: 1px solid #ddd;
					margin: 30px 0;
				}

				.privacy-footer {
					margin-top: 40px;
					font-size: 0.9rem;
					color: #777;
					text-align: center;
				}

				@media (max-width: 768px) {
					.privacy-container {
						padding: 30px 20px;
					}

					.privacy-title {
						font-size: 2rem;
					}
				}
			`}</style>
			<div className='privacy-container'>
				<h1 className='privacy-title'>Politica de Confidențialitate</h1>

				<p className='privacy-meta'>
					Ultima actualizare: <strong>11 februarie 2026</strong> <br />
					Dată intrare în vigoare: <strong>11 februarie 2026</strong>
				</p>

				<p>
					Această Politică de Confidențialitate descrie politicile <strong>NEGRU ADRIAN PERSOANA FIZICA AUTORIZATA.</strong>, Str. Alexandru Sahia, Nr.15, Cugir. <br />
					E-mail: <a href='mailto:contact@adi-mag.ro'>contact@adi-mag.ro</a> 
				</p>

				<p>
					Prin accesarea sau utilizarea site-ului <a href='https://www.adi-mag.ro'>www.adi-mag.ro</a>, îți
					exprimi consimțământul pentru colectarea și utilizarea datelor în conformitate cu această
					politică. Dacă nu ești de acord, te rugăm să nu utilizezi Serviciul.
				</p>

				<hr />

				<h2>1. Informațiile pe care le colectăm</h2>
				<p>Vom colecta și procesa următoarele informații personale despre tine pe o durata nedeterminata, acestea fiind stocate in baza noastra de date.</p>
                    <p>Aceste date vor fii sterse complet din baza noastra de date in urma stergerii definitive a contului de client, fie din panoul de control al contului ( sectiunea Contul Meu ) sau printr-un mail catre <b>contact@adi-mag.ro</b> de pe email-ul asociat contului.</p>
				<ul>
					<li>Nume</li>
					<li>E-mail</li>
					<li>Telefon mobil</li>
					<li>Adresă de livrare</li>
					<li>Informații de plată</li>
				</ul>

				<h2>2. Cum folosim informațiile tale</h2>
				<p>Informațiile colectate vor fi utilizate pentru:</p>
				<ul>
					<li>Crearea contului de utilizator</li>
					<li>Procesarea plăților</li>
					<li>Gestionarea comenzilor clienților</li>
				</ul>
				<p>
					Dacă dorim să folosim informațiile tale în alte scopuri, îți vom solicita consimțământul și le
					vom utiliza doar după ce acesta a fost acordat.
				</p>

                    <p>Temeiurile legale: executarea contractului (art.6 lit.b GDPR), obligație legală (art.6 lit.c GDPR), consimțământ (art.6 lit.a GDPR).</p>

				<h2>3. Păstrarea informațiilor tale</h2>
				<p>
					Informațiile personale sunt păstrate între <strong>90 de zile</strong> și{" "}
					<strong>2 ani</strong> după ce conturile devin inactive, sau atât timp cât este necesar pentru
					scopurile menționate.
				</p>

				<h2>4. Drepturile tale</h2>
				<p>
					În funcție de legea aplicabilă, poți solicita acces, rectificare sau ștergere a datelor tale,
					restricționarea procesării sau transmiterea datelor către o altă entitate. Ne poți contacta la{" "}
					<a href='mailto:contact@adi-mag.ro'>contact@adi-mag.ro</a>.
				</p>

				<h2>5. Cookie-uri</h2>
				<p>
					Pentru detalii privind cookie-urile, te rugăm să consulți{" "}
					<a href='https://www.adi-mag.ro/politica-cookie/'>Politica de cookie-uri</a>.
				</p>

				<h2>6. Securitate</h2>
				<p>
					Ne angajăm să protejăm datele tale și folosim măsuri rezonabile de securitate. Totuși, nicio
					metodă electronică nu este complet sigură, de aceea nu putem garanta securitatea absolută.
				</p>

				<h2>7. Responsabil pentru protecția datelor</h2>
				<p>
					Pentru întrebări legate de această politică, ne poți contacta la: <strong>NEGRU ADRIAN PERSOANA FIZICA AUTORIZATA.</strong>
					, Str. Alexandru Sahia, Nr.15, Cugir. <br />
					E-mail: <a href='mailto:contact@adi-mag.ro'>contact@adi-mag.ro</a>. 
             
				</p>


                    <h2>7. Destinatarii / terții </h2>
				<p>
					Datele despre informatii din contul de client, cat si comenzi pot fii impartasite cu partenerii nostrii. 
				</p>
				
                    <h2>8. Drepturile persoanei vizate </h2>
				<p>
                         <ul>
                              <li>Dreptul de acces – copii gratuite la prima solicitare; adrese: contact@adi-mag.ro, Ilfov, ORȘ.BRAGADIRU, STR. VERII, NR. 38A, CUI 50155117;.</li>
                              <li>Dreptul la rectificare – corectarea/ completarea datelor inexacte/incomplete.</li>
                              <li>Dreptul la ștergere – în limitele legii (dreptul de a fi uitat).</li>
                              <li>Dreptul la restricționare – inclusiv când se contestă exactitatea.</li>
                              <li>Dreptul de a obiecta – în special pentru marketing; datele se anonimizează prompt.</li>
                              <li>Dreptul de a retrage consimțământul – fără a afecta legalitatea prelucrării anterioare; operare în max. 3 zile lucrătoare.</li>
                              <li>Dreptul de a depune plângere – la ANSPDCP (https://www.dataprotection.ro/ ).</li>
                              <li>Decizii automate & profilare – cu consimțământ; date securizate; posibilitatea intervenției umane (contact@adi-mag.ro).</li>
                              <li></li>
                         </ul>
					Puteti oricand accesa / rectifica / sterge contul de client. In urma acestei actiuni datele dumneavoastra nu vor mai fii stocate in baza noastra de date. 
                         Solicitările pot fi trimise la <a href="mailto:contact@adi-mag.ro">contact@adi-mag.ro</a>
				</p>

                    <h2>9. Transferurile internationale de date</h2>
				<p>
					La momentul actual, anumite date precum certificatele de garantie, pot fii transferate international catre furnizorul nostru de servicii de stocare <a href="https://aws.amazon.com/">AWS</a> . 
                         
				</p>

        
			</div>
		</div>
	);
}
